import styled from '@emotion/styled';
import useYoutubeChannelTabs from '@api/hooks/youtube-course/useYoutubeChannelTabs';
import { useMemo } from 'react';
import { emptyList } from '@constants/empty';
import { Spacings, Fonts } from '@styles/index';

const TabListContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: scroll;
  height: 70px;
  margin-bottom: ${Spacings.SPACING_20};
`;

const TabButton = styled.button`
  background-color: transparent;
  min-width: 150px;
  box-shadow: unset;
  border: ${Spacings.SPACING_1} solid
    ${({ $isActiveTab }) =>
      $isActiveTab ? 'var(--color-i-black)' : 'var(--color-i-divider)'};
  border-radius: ${Spacings.SPACING_1B};
  padding: 0 ${Spacings.SPACING_15};
  margin: ${Spacings.SPACING_15};
  margin-left: 0;
  font-size: ${Fonts.P1};
  font-weight: ${Fonts.SEMIBOLD};
  cursor: pointer;
`;

const TabList = ({ goalUID }) => {
  const { youtubeChannelTabsData } = useYoutubeChannelTabs(goalUID);

  // Reorder Tabs too bring Free courses to 1st Index
  const courseTabs = useMemo(() => {
    const allTabs = [...(youtubeChannelTabsData || emptyList)];
    const freeCourseIndex = allTabs.findIndex(
      (tab) => tab?.tabName === 'Free Courses'
    );
    const freeCourseTabDetails = allTabs.find(
      (tabDetails) => tabDetails?.tabName === 'Free Courses'
    );
    if (freeCourseIndex !== -1) {
      allTabs.splice(freeCourseIndex, 1);
      allTabs.unshift(freeCourseTabDetails);
    }
    return allTabs;
  }, [youtubeChannelTabsData]);

  return (
    <TabListContainer>
      {courseTabs?.map((tabDetails) => (
        <TabButton
          $isActiveTab={tabDetails?.tabName === 'Free Courses'}
          key={tabDetails.id}
          onClick={() => {
            if (
              tabDetails.tabTargetUrl &&
              tabDetails?.tabName !== 'Free Courses'
            ) {
              window.location.href = tabDetails.tabTargetUrl;
            }
          }}
        >
          {tabDetails?.tabName}
        </TabButton>
      ))}
    </TabListContainer>
  );
};

export default TabList;
